import { LaneType } from 'common-types';
import { GroupRole } from '../GroupRole';
import { DateRangeType } from '../baseTypes/DateRangeType';
import { TimeRangeType } from '../baseTypes/TimeRangeType';

export type TimeAvailabilityFeatureProperties = {
  availabilities: WeeklyAvailability[];
  unavailableDates: UnavailableDateAvailability[];
};

export type WeeklyAvailability = {
  _id: LaneType.UUID;
  allGroupRoles: boolean;
  groupRole?: Pick<GroupRole, '_id'> | null;
  weekTimeRules: TimeAvailabilityWeekRule;
  isAvailableAnytime: boolean;
};

export type UnavailableDateAvailability = {
  _id: LaneType.UUID;
  allGroupRoles: boolean;
  groupRole?: GroupRole | null;
  dateRange: DateRangeType;
};

export enum DaysInWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export type TimeAvailabilityWeekRule = {
  [DaysInWeek.MONDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.TUESDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.WEDNESDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.THURSDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.FRIDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.SATURDAY]: TimeAvailabilityDayRule;
  [DaysInWeek.SUNDAY]: TimeAvailabilityDayRule;
};

export type WeekDay = Extract<keyof TimeAvailabilityWeekRule, string>;

export type TimeAvailabilityDayRule = {
  _id: LaneType.UUID;
  isOpen: boolean;
  timeRanges: TimeRangeType[];
  isAvailableAllDay: boolean;
};
